export default __webpack_public_path__ + "static/media/Event CUBE 1.1a842859.gif";